"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TRANSITION = exports.BASE_TIMING = exports.BASE_DURATION = exports.DURATION_LONG = exports.DURATION = void 0;
exports.DURATION = {
    SHORT: '0.2s',
    LONG: '0.5s',
};
exports.DURATION_LONG = exports.DURATION.LONG;
exports.BASE_DURATION = exports.DURATION.SHORT;
exports.BASE_TIMING = 'ease-in-out';
exports.DEFAULT_TRANSITION = "all ".concat(exports.BASE_DURATION, " ").concat(exports.BASE_TIMING);
//# sourceMappingURL=index.js.map